export default "__VITE_ASSET__79c38ec4__"